import { Routes } from '@angular/router';
import { InventoryDetailsComponent } from './inventory-details.component';
import { LotComponent } from './lot.component';
import { RouteAccessService } from '../../../shared';
import { TransactionComponent } from './transaction.component';
import { TransactionDetailsModalComponent } from './transaction-details-modal.component';
import { InventoryDetailsMainComponent } from './inventory-details-main.component';
import { LotMainComponent } from './lot-main.component';

export const INVENTORY_DETAILS_ROUTES: Routes = [
    {
        path: 'inventory-details',
        component: InventoryDetailsComponent,
        canActivate: [RouteAccessService],
        children: [
            {
                path: '',
                redirectTo: 'lot',
                pathMatch: 'full'
            },
            {
                path: 'lot',
                component: LotComponent
            },
            {
                path: 'transaction',
                component: TransactionComponent
            }
        ]
    },
    {
        path: 'transaction',
        component: TransactionComponent,
        canActivate: [RouteAccessService]
    },
    {
        path: 'transaction-details-dialog',
        component: TransactionDetailsModalComponent,
        canActivate: [RouteAccessService]
    },
    {
        path: 'inventory-details-main',
        component: InventoryDetailsMainComponent,
        canActivate: [RouteAccessService],
        outlet: 'popup',
        children: [
            {
                path: '',
                redirectTo: 'lot',
                pathMatch: 'full',
                outlet: 'modalContent'
            },
            {
                path: 'lot',
                component: LotMainComponent,
                outlet: 'modalContent'
            },
            {
                path: 'transaction',
                component: TransactionComponent,
                outlet: 'modalContent'
            }
        ]
    },
];
